export default function NotFound() {
    return (
        <div style={{textAlign: "center", marginTop: "30vh"}}>
            <h1 >Oops! You seem to be lost.</h1>
            <p>This page is not found</p>
        </div>
    );
}
